<!-- eslint-disable vue/no-v-html -->
<script>
import Checkbox from '@components/mental-health-survey/checkbox/quick-checkbox.vue'
import Button from '@components/mental-health-survey/button/quick-button.vue'
import Emoji from '@components/mental-health-survey/emoji/quick-emoji.vue'
import Radio from '@components/mental-health-survey/radio/quick-radio.vue'
import Dropdown from '@components/mental-health-survey/dropdown/quick-dropdown.vue'
import { mentalHealthSurveyQuestionnaire } from '@/src/services/safehaven/MentalHealthSurveyQuestionnaire'
import { actionService } from '@services/safehaven/ActionService'
import store from '@state/store'
export default {
  components: {
    Checkbox,
    Button,
    Radio,
    Emoji,
    Dropdown,
  },

  data() {
    return {
      resultDialog: false,
      isloading: false,
      loading: false,
      disable: true,
      oldArray: '',
      routeData: '',
      general: false,
      profileQuestionnaire: false,
      phq2: false,
      phq7: false,
      phq9: false,
      btnTitle: '',
      profileQuestions: [],
      answers: [],
      questions: [],
      phq2Questions: [],
      phq9Questions: [],
      userData: null,
    }
  },
  computed: {
    computedMenuItems() {
      return this.$store.state.profileQuestions.questionnaire
    },

    disableSubmit() {
      var freqQuestion = this.$store.state.profileQuestions.questionnaire.find(
        (x) => x.model_input_key === 'frequency'
      )
      return freqQuestion.answers ? freqQuestion.answers.key === 'null' : true
    },
    getTitle() {
      if (this.general) {
        return 'Quick Profile Questionnaire'
      } else {
        return 'Depression Assessment'
      }
    },
    getDescription() {
      if (this.general) {
        return 'Answer these brief questions to help us evaluate your mental health and get you started on the right path.'
      } else {
        return 'This self-screening tool helps you measure the presence and/or severity of depression you might have. Answer the following 9 questions according to the experiences you’ve had <strong>over the last 2 weeks.</strong>'
      }
    },
  },
  watch: {
    profileQuestions: {
      handler: function (newValue) {
        store.dispatch('profileQuestions/setQuestionnaire', newValue)
      },
      deep: true,
    },
  },
  created() {
    this.routeData = this.$route?.path.split('/')[3]
    this.checkRoute()
    this.getGeneralData()
  },

  async mounted() {
    this.userData = this.$store.state.auth.currentUser
    this.orgName = this.userData.user.user_org_details[0].org_name
  },
  methods: {
    changeData() {},
    checkRoute() {
      this.profileQuestionnaire = true
      this.btnTitle = 'See your results'
    },
    submitData() {
      var questionArray = []
      if (this.profileQuestionnaire) questionArray = this.profileQuestions
      else if (this.phq2) questionArray = this.phq2Questions
      else if (this.phq9) questionArray = this.phq9Questions
      var answer = []
      // to add answers into the questions array

      for (const question of questionArray)
        if (question.answers) {
          // if answer is present then map answer
          var obj = {
            ques_id: question.question_id,
            ques_title: question.question_title,
            ques_type: question.question_type,
            ans: question.answers.key
              ? question.answers.key === 'null'
                ? null
                : question.answers
              : question.answers,
            model_input_key: question.model_input_key,
          }
          answer.push(obj)
        } else {
          // if answer is not present send empty object
          var obj1 = {
            ques_id: question.question_id,
            ques_title: question.question_title,
            ques_type: question.question_type,
            ans:
              question.question_options.find(
                (x) => x.value === question.question_options_default
              ).key === 'null'
                ? null
                : question.question_options.find(
                    (x) => x.value === question.question_options_default
                  ),
            model_input_key: question.model_input_key,
          }
          answer.push(obj1)
        }

      this.saveAnswers(answer)
    },
    async getGeneralData() {
      // based on result we will get the respective questions set
      this.isloading = true

      if (this.$route.params.result === 'Low') {
        // when result is low call pq2
        try {
          var req = {
            category: 'Depression',
            result: 'Low',
            answer_id: this.$route.params.answerId,
          }
          await mentalHealthSurveyQuestionnaire
            .getAllQuestions(req)
            .then((res) => {
              this.isloading = false
              this.phq2Questions = res.data.survey_questionnaire
            })
        } catch (error) {
          this.isloading = false
          console.warn(error)
        }
      } else if (
        this.$route.params.result === 'Positive' ||
        this.$route.params.result === 'Moderate'
      ) {
        // when result is positive or moderate  call pq9
        try {
          var reqObj = {
            category: 'Depression',
            result: this.$route.params.result,
            answer_id: this.$route.params.answerId,
          }
          await mentalHealthSurveyQuestionnaire
            .getAllQuestions(reqObj)
            .then((res) => {
              this.isloading = false
              this.phq9Questions = this.mapAnswer(
                res.data.survey_questionnaire,
                res.data.survey_ans.itr2_answers
              )
            })
        } catch (error) {
          this.isloading = false
          console.warn(error)
        }
      } else {
        // when result is not decleared call general question set
        try {
          var request = { category: 'Depression', result: '', answer_id: 0 }
          await mentalHealthSurveyQuestionnaire
            .getAllQuestions(request)
            .then((res) => {
              this.isloading = false

              this.profileQuestions = this.mapAnswer(
                res.data.survey_questionnaire,
                res.data.survey_ans.itr1_answers
              )
            })
        } catch (error) {
          this.isloading = false
          console.warn(error)
        }
      }
    },

    async saveAction(req) {
      try {
        await actionService.saveAction(req).then((res) => {})
      } catch (error) {
        this.isLoading = false
        console.warn(error)
      }
    },

    mapAnswer(question, answer) {
      if (answer) {
        for (var ans of answer) {
          var questionObj = question.find((x) => x.question_id === ans.ques_id)

          if (questionObj) questionObj.answers = ans.ans
        }
      }

      return question
    },
    getDependent(question) {
      if (question.dependent_question_id) {
        if (
          this.profileQuestions.find(
            (x) => x.question_id === question.dependent_question_id
          ).ans
        ) {
          return (
            this.profileQuestions.find(
              (x) => x.question_id === question.dependent_question_id
            ).ans?.key === 1
          )
        } else return true
      } else return false
    },
    async saveAnswers(answer) {
      // save answer based on response & navigate to respective screen baseed on result
      try {
        var request = {
          phq_number: 9,
          category: 'Depression',
          ans_id: this.$route.params.answerId
            ? this.$route.params.answerId
            : null,
          answers: answer,
          validic_details: {
            validic_uid: this.userData.user.validic_user.uid
              ? this.userData.user.validic_user.uid
              : null,
            device_type: this.userData.user.validic_user.uid
              ? this.userData.user.validic_user.sources[0]
                ? this.userData.user.validic_user.sources[0].type
                : null
              : null,
          },
        }
        this.loading = true
        await mentalHealthSurveyQuestionnaire
          .saveAllAnswers(request)
          .then((res) => {
            this.loading = false
            let action = 'B1'
            this.userData.user.answer_saved = true
            this.userData.user.is_frequency_set = true
            store.dispatch('auth/setCurrentUser', this.userData)
            if (res.data.score < 5) {
              // if result is low navigate to phq2
              action = 'B1'
              this.$router.push({
                name: 'health-action-result',
                params: {
                  action: action,
                  answerId: res.data.ans_id,
                  result: 'Low',
                },
              })
            } else if (res.data.score >= 5 && res.data.score < 15) {
              // if result is moderate navigate to phq9
              action = 'C'
              this.$router.push({
                name: 'health-action-result',
                params: {
                  action: action,
                  answerId: res.data.ans_id,
                  result: 'Moderate',
                },
              })
            } else if (res.data.score >= 15) {
              // if result is high navigate to health action
              this.$router.push({
                name: 'health-action-result',
                params: {
                  action: 'D',
                },
              })
            }
          })
      } catch (error) {
        console.warn(error)
        this.loading = false
      }
    },

    navigatetoHome() {
      this.$router.push({
        name: 'dashboard',
      })
    },
  },
}
</script>

<template>
  <div :class="[$style.pageContainer]">
    <div
      :class="[
        $style.questionWrapp,
        [$vuetify.breakpoint.mobile ? 'mx-0' : 'mx-5'],
      ]"
    >
      <v-row :class="[$vuetify.breakpoint.mobile ? 'px-4 mt-0' : 'mt-0']">
        <v-col cols="12" :class="[$vuetify.breakpoint.mobile ? 'pt-0' : '']">
          <h3 :class="$style.pageTitle" class="mb-2">
            {{ getTitle }}
          </h3>
        </v-col>
      </v-row>
      <v-row :class="[$vuetify.breakpoint.mobile ? 'px-4 mt-0' : 'mt-0']">
        <v-col
          cols="12"
          md="12"
          sm="12"
          lg="3"
          xl="3"
          :class="[$vuetify.breakpoint.mobile ? 'pt-0' : '']"
        >
          <div v-if="general">
            <v-img
              v-if="!$vuetify.breakpoint.mobile"
              height="134"
              contain
              :src="
                require('@assets/images/safehaven/health-survey/MentalHealth.svg')
              "
            ></v-img>
          </div>
          <div v-else>
            <v-img
              v-if="!$vuetify.breakpoint.mobile"
              height="134"
              contain
              :src="
                require('@assets/images/safehaven/health-survey/Depression-new.svg')
              "
            ></v-img>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="12"
          sm="12"
          lg="9"
          xl="9"
          class="d-flex align-center"
        >
          <div
            :class="[
              $style.gettingInfo,
              [$vuetify.breakpoint.mobile ? 'mb-0' : ''],
            ]"
            v-html="getDescription"
          ></div>
        </v-col>
      </v-row>
      <v-row :class="[$vuetify.breakpoint.mobile ? 'px-4 mt-0' : 'mt-4']">
        <v-col
          cols="12"
          md="12"
          sm="12"
          lg="3"
          xl="3"
          :class="[$vuetify.breakpoint.mobile ? 'pt-0' : '']"
        ></v-col>
        <v-col cols="12" md="12" sm="12" lg="9" xl="9" class="">
          <v-container>
            <v-row>
              <v-card
                v-if="isloading"
                width="100%"
                color="offwhite"
                outlined
                rounded="lg"
                loading
                class="px-0"
              >
                <template slot="progress">
                  <v-progress-linear
                    v-if="isloading"
                    color="primary"
                    indeterminate
                  ></v-progress-linear>
                  <div v-else :class="$style.loaderPlaceholder"></div>
                </template>
              </v-card>
              <div :class="$style.submitForm">
                <v-form
                  v-if="profileQuestionnaire"
                  id="check-login-form"
                  @submit.prevent="submitData"
                >
                  <v-col
                    v-for="(question, i) in computedMenuItems"
                    :key="i"
                    cols="12"
                    :class="$style.bodrderclss"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                  >
                    <Checkbox
                      v-if="question.question_type === 'checkbox'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Checkbox>
                    <Button
                      v-if="question.question_type === 'button'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Button>

                    <Dropdown
                      v-if="question.question_type === 'list_single_select'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers ? question.answers : 'null'"
                      :default-value="question.question_options_default"
                      :isdisabled="getDependent(question)"
                    ></Dropdown>
                    <Emoji
                      v-if="question.question_type === 'Emojis'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Emoji>
                    <Radio
                      v-if="question.question_type === 'radiobutton'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Radio>
                  </v-col>
                </v-form>
                <v-form
                  v-if="general"
                  id="check-login-form"
                  @submit.prevent="submitData"
                >
                  <v-col
                    v-for="(question, i) in questions"
                    :key="i"
                    cols="12"
                    :class="$style.bodrderclss"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                  >
                    <v-card
                      v-if="isloading"
                      width="100%"
                      color="offwhite"
                      outlined
                      rounded="lg"
                      loading
                      class="px-0"
                    >
                      <template slot="progress">
                        <v-progress-linear
                          v-if="isloading"
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                        <div v-else :class="$style.loaderPlaceholder"></div>
                      </template>
                    </v-card>
                    <Checkbox
                      v-if="question.question_type === 'checkbox'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Checkbox>
                    <Button
                      v-if="question.question_type === 'button'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Button>
                    <Dropdown
                      v-if="question.question_type === 'list_single_select'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                      :isdisabled="false"
                      :default-value="question.question_options_default"
                    ></Dropdown>
                    <Emoji
                      v-if="question.question_type === 'Emojis'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Emoji>
                    <Radio
                      v-if="question.question_type === 'radiobutton'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Radio>
                  </v-col>
                </v-form>
                <v-form
                  v-if="phq2"
                  id="check-login-form"
                  @submit.prevent="submitData"
                >
                  <v-col
                    v-for="(question, i) in phq2Questions"
                    :key="i"
                    cols="12"
                    :class="$style.bodrderclss"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                  >
                    <v-card
                      v-if="isloading"
                      width="100%"
                      color="offwhite"
                      outlined
                      rounded="lg"
                      loading
                      class="px-0"
                    >
                      <template slot="progress">
                        <v-progress-linear
                          v-if="isloading"
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                        <div v-else :class="$style.loaderPlaceholder"></div>
                      </template>
                    </v-card>
                    <Checkbox
                      v-if="question.question_type === 'checkbox'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Checkbox>
                    <Button
                      v-if="question.question_type === 'button'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Button>
                    <Dropdown
                      v-if="question.question_type === 'list_single_select'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                      :isdisabled="getDependent(question)"
                    ></Dropdown>
                    <Emoji
                      v-if="question.question_type === 'Emojis'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Emoji>
                    <Radio
                      v-if="question.question_type === 'radiobutton'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Radio>
                  </v-col>
                </v-form>
                <v-form
                  v-if="phq7"
                  id="check-login-form"
                  @submit.prevent="submitData"
                >
                  <v-col
                    cols="12"
                    :class="$style.bodrderclss"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                  >
                    <p :class="$style.sectionTitle"
                      >Sorry to hear that. Please answer a few more
                      questions.</p
                    >
                  </v-col>
                </v-form>
                <v-form
                  v-if="phq9"
                  id="check-login-form"
                  @submit.prevent="submitData"
                >
                  <v-col
                    v-for="(question, i) in phq9Questions"
                    :key="i"
                    cols="12"
                    :class="$style.bodrderclss"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                  >
                    <Checkbox
                      v-if="question.question_type === 'checkbox'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Checkbox>
                    <Button
                      v-if="question.question_type === 'button'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Button>
                    <Dropdown
                      v-if="question.question_type === 'list_single_select'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                      :isdisabled="false"
                    ></Dropdown>
                    <Emoji
                      v-if="question.question_type === 'Emojis'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Emoji>
                    <Radio
                      v-if="question.question_type === 'radiobutton'"
                      v-model="question.answers"
                      :question-id="question.question_id"
                      :question-title="question.question_title"
                      :question-options="question.question_options"
                      :question-type="question.question_type"
                      :selected="question.answers"
                    ></Radio>
                  </v-col>
                </v-form>
              </div>
            </v-row>
            <v-row class=""
              ><v-col
                cols="12"
                :class="$style.paddingclss"
                class="px-0 pb-0"
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-btn
                  type="submit"
                  :loading="loading"
                  :class="[
                    loading ? 'disabled-btn' : 'primary-btn',
                    $vuetify.breakpoint.smAndDown ? 'full-width-btn' : '',
                  ]"
                  form="check-login-form"
                >
                  {{ btnTitle }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-dialog v-model="resultDialog" width="400">
          <v-card>
            <span :class="$style.dialogClose" @click="resultDialog = false">
              <v-icon>mdi-close</v-icon>
            </span>

            <v-card-title class="pt-6">
              Thanks for your responses
            </v-card-title>
            <v-card-text>
              <p class="modelText">
                If you ever experience issues, you can proceed to Health Check
                and share this information with your healthcare provider.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :class="$style.modelOk"
                rounded="pill"
                variant="text"
                @click="navigatetoHome"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.pageContainer {
  display: flex;
  justify-content: center;
  width: 100%;
}
.modelOk {
  display: flex;

  /* Inside auto layout */

  flex: none;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  order: 2;
  width: 123px;
  height: 45px !important;
  padding: 8px 24px;

  /* Queen Blue */
  font-size: 14px !important;
  color: #fff !important;
  background-color: #082787 !important;
}
.pageTitle {
  margin-bottom: 10px;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}
.gettingInfo {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}
.questionWrapp {
  max-width: 720px;
  padding: 20px 30px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.submitForm {
  width: 100%;
}
.bodrderclss {
  border-bottom: 1px solid #ccc;
}
.sectionTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #454648;
}
.modelText {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  letter-spacing: 0;
}

.dialogClose {
  position: absolute;
  top: 12px;
  right: 16.56px;
  width: 18.44px;
  height: 18.44px;
  color: #d1d1d1;
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .questionWrapp {
    padding: 20px 10px;
    background: #fff;
    border: 1px solid #93c0e8;
    border-radius: 4px;
  }
}
</style>
